export default function stringToBoolean(string) {
    switch (string) {
        case 'TRUE':
        case 'True':
        case 'true':
        case '1':
            return true;
        case 'FALSE':
        case 'False':
        case 'false':
        case '0':
        case null:
            return false;
        default:
            return Boolean(string);
    }
}
